// extracted by mini-css-extract-plugin
module.exports = {"textareaAddMess":"FormControls_textareaAddMess__3PS5L","input":"FormControls_input__2kKs_","error":"FormControls_error__2xnxl","spanError":"FormControls_spanError__2vC1Z"};